import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { routerActions } from 'react-router-redux'

import ProjectCard from './Card'
import {List, ListItem} from 'material-ui/List'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { propertyOpenProjects } from 'selectors/project'
import { projects } from 'selectors/entities'

let select = dirtyRead((state, props) => ({
	propertyOpenProjects: propertyOpenProjects(state, props.propertyID)
}))

export class ProjectList extends Component {
	render() {
		let { props } = this
	    return (
			<List
				style={{
					backgroundColor: "transparent"
					, paddingTop: "0"
				}}
			>
				{props.propertyOpenProjects.map(project =>
					<ProjectCard projectId={project._id} />
				)}
			</List>
	    )
	}
}
export default connect(select, R.mergeAll([dataActions, routerActions]))(ProjectList)



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/projects/List.js